import type { SavedCard } from '../checkout/cards'
import { cardTail } from '../checkout/model'

/** Как карту называть людям: «Uzcard •• 9999». */
export const cardName = (card: SavedCard) =>
  `${card.vendor ? `${card.vendor} ` : ''}${cardTail(card.number)}`
